// extracted by mini-css-extract-plugin
module.exports = {"root":"PlayerVolume_root__3TjPy","icon":"PlayerVolume_icon__3FWVG"};